// localStorage / sessionStorage keys for auth state.
// Shared between the app (src/utils/auth.tsx) and Cypress (cypress/support/commands.ts)
// so the key strings are defined in exactly one place.
export const viewAsTokenKey = "viewAsToken";
export const normalTokenKey = "normalToken";
export const profileKey = "profile";
